import arrow from "../../Images/white-arrow.png"
import work1 from "../../Images/work-1.png"
import work2 from "../../Images/work-2.png"
import work3 from "../../Images/work-3.png"
import work4 from "../../Images/work-4.png"
import work5 from "../../Images/work-5.png"
import work6 from "../../Images/work-6.png"
import work7 from "../../Images/work-7.png"
import work8 from "../../Images/work-8.png"
import work9 from "../../Images/work-9.png"


export const WorkData = [
    {
        id : 1,
        name : "Full body massage",
        title : "Spa and Beauty",
        img : work1,
        arrow : arrow
    },
    {
        id : 2,
        name : "Head Massage",
        title : "Spa and Beauty",
        img : work2,
        arrow : arrow
    },
    {
        id : 3,
        name : "Aroma therapy",
        title : "Wellness & Spa",
        img : work3,
        arrow : arrow
    },
    {
        id : 4,
        name : "Sauna relax",
        title : "Spa and Beauty",
        img : work4,
        arrow : arrow
    },
    {
        id : 5,
        name : "Finnish sauna",
        title : "Spa and Beauty",
        img : work5,
        arrow : arrow
    },
    {
        id : 6,
        name : "Facial Spa",
        title : "Wellness & Spa",
        img : work6,
        arrow : arrow
    },
    {
        id : 7,
        name : "A Place of True Splendor",
        title : "Spa and Beauty",
        img : work7,
        arrow : arrow
    },
    {
        id : 8,
        name : "Face masks",
        title : "Spa and Beauty",
        img : work8,
        arrow : arrow
    },
    {
        id : 9,
        name : "Geothermal spa",
        title : "Wellness & Spa",
        img : work9,
        arrow : arrow
    },
]

